<div
  class="col-12 mb-4 flex flex-col mt-4"
  *ngIf="fieldsData?.records?.length > 0"
>
  <span class="text-md font-semibold text-gray-900"
    >Connected Integrations</span
  >
  <span class="text-2sm font-medium text-gray-500"
    >Seamlessly integrate your security ecosystem for unified visibility and
    automated operations.</span
  >
</div>

<div
  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6"
  *ngIf="isLoading"
>
  <div
    *ngFor="let s of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
    class="bg-white dark:bg-coal-700 border rounded-xl p-5 flex flex-col items-center justify-center relative"
  >
    <!-- Skeleton Bookmark Icon -->
    <div class="absolute top-0 left-3">
      <div
        class="shimmer-item bg-gray-300 dark:bg-coal-700 w-7 h-7 rounded"
      ></div>
    </div>

    <!-- Skeleton App Logo -->
    <div
      class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded w-14 h-10 mb-4 mt-3"
    ></div>

    <!-- Skeleton App Name -->
    <div
      class="shimmer-item bg-gray-300 dark:bg-coal-700 w-24 h-4 rounded mb-2"
    ></div>

    <!-- Skeleton Description -->
    <div
      class="shimmer-item bg-gray-300 dark:bg-coal-700 w-36 h-4 rounded"
    ></div>
  </div>
</div>
<div class="grid grid-cols-1 md:grid-cols-4 gap-5 mt-4">
  <ng-container *ngFor="let option of fieldsData?.records">
    <span
      class="border-primary bg-light-primary text-gray-700 mb-3 inline-flex items-center gap-2 px-3 py-1 rounded-lg border text-sm font-medium transition-all hover:bg-secondary-active"
    >
      <img
        [src]="getPlatformIcon(option)"
        (error)="onImageError($event, option)"
        class="h-20px w-20px"
      />

      <span class="text-2sm font-semibold text-gray-700">{{
        option.platformName
      }}</span>
    </span>
  </ng-container>
</div>
<div
  class="flex flex-1 items-center justify-center text-center flex-col graph-card"
  *ngIf="fieldsData?.records?.length == 0"
>
  <span class="text-md text-gray-900 font-medium">No Data Available</span>
  <span class="text-sm text-gray-800">There is no data to display yet</span>
</div>
